import "./validationAddMethods";
import applyDiscount from "../applyDiscount"; // Add the discount tag
import resetForm from "../resetForm";
import {
  disableSubmitButton,
  enableSubmitButton,
} from "./enableOrDisableSubmitButton";
import "./checkEmail";
import "./checkEmployer";

// TODO confirm it's not used anywhere (it looks like not). Then remove. And enableOrDisableSubmitButton.js.
$('[for="other"]').on("click", function () {
  resetForm($questionsForm);
  disableSubmitButton();
});

// TODO confirm it's not used anywhere (it looks like not). Then remove. And enableOrDisableSubmitButton.js.
$('[for="home"]').on("click", function () {
  // reset form to original fields
  document.querySelector(".questionsForm").reset();
  enableSubmitButton();
});
